import * as http from 'utils/http';
import {
  updateDriver as updateDriverReducer,
  removeDriver as RemoveDriverReducer,
} from 'redux/modules/carrier-section/duck';

export const createDriver = (driver) => {
  return (dispatch, getState, config) => {
    return http
      .post(`${config.API_URL}drivers/`, {
        ...driver,
        vehicles: [],
        tax_number:
          typeof driver.tax_number === 'string'
            ? driver.tax_number.toUpperCase()
            : driver.tax_number,
      })
      .catch((err) => {
        throw err;
      })
      .then((response) => {
        dispatch(updateDriverReducer(response));
        return response;
      });
  };
};

export const updateDriver = (driver) => {
  return (dispatch, getState, config) => {
    return http
      .patch(config.API_URL + 'drivers/' + driver.id + '/', {
        ...driver,
        vehicles: undefined,
        tax_number:
          typeof driver.tax_number === 'string'
            ? driver.tax_number.toUpperCase()
            : driver.tax_number,
      })
      .catch((err) => {
        throw err;
      })
      .then((response) => {
        dispatch(updateDriverReducer(response));
        return response;
      });
  };
};

export const removeDriver = (driver) => {
  return (dispatch, getState, config) => {
    return http
      .post(`${config.API_URL}drivers/${driver.id}/remove/`, driver)
      .then((response) => {
        dispatch(RemoveDriverReducer(response));
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };
};
